'use client';
import { ComponentProps, ElementType, useContext } from 'react';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

type Props<T extends ElementType = 'p'> = {
    as?: T;
} & ComponentProps<T>;
export const ProductDetailInfoDescription = <T extends ElementType = 'p'>({
    as: Element = 'p',
}: Props<T>) => {
    const { currentItem } = useContext(ProductDetailContext);
    const getLocalizedValue = useGetLocalizedValue();
    if (!currentItem?.shortDescription) {
        return null;
    }

    const description = getLocalizedValue(currentItem.shortDescription);
    return (
        <Element className="product-detail__info-description" data-testid="product-detail-description">
            {description}
        </Element>
    );
};
